// @flow
import type { WidgetNames } from './types'

export const WIDGETS: $EnumMap<WidgetNames, string, { [WidgetNames]: string }> = Object.freeze({
  MENU: 'MENU',
  REVIEWS: 'REVIEWS',
  FEATURED_COACHES: 'FEATURED_COACHES',
  COACH_ENROLLMENT: 'COACH_ENROLLMENT',
  SHORT_FORM: 'SHORT_FORM',
  USER_TYPE_PROMPT: 'USER_TYPE_PROMPT',
})
